import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import MyPlaylistForm from "./MyPlaylistForm";
import {
  setpreviewLogout,
  setpreviewPlaylistObject,
} from "../../redux/slices/Preview";
import { useDispatch, useSelector } from "react-redux";
import MyLayoutForm from "./MyLayoutForm";
import { InputLayoutForm } from "./InputLayoutForm";
import { ActionNotSupportedAlert } from "../ActionNotSupportedAlert"
import { useTheme, useMediaQuery } from "@mui/material";


const LayoutSmallCardComponent = ({ searchQuery }) => {
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const dispatch = useDispatch();
  const eventcustomisations = useSelector(
    (state) => state?.eventcustomisations?.eventcustomisations
  );
  const templates = useSelector((state) => state?.template?.template);
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay?.dataToDisplay
  );

  const playlist = useSelector((state) => state?.playlist?.playlist);
  const layout = useSelector((state) => state?.layout?.layout);
  const [selectedLayoutId, handleSelectLayout] = useState();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [showNotSupportedActionModal, setShowNotSupportedActionModal] = useState(false)

  const filteredLayouts = layout?.filter(
    (layoutItem) =>
      !searchQuery ||
      layoutItem.name.toLowerCase().includes(searchQuery.toLowerCase())
  );


  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {filteredLayouts?.map((layoutItem) => {
           
            const associatedPlaylist = playlist?.find(
              (playlistEntry) => playlistEntry.id === layoutItem.playlistId
            );
            const isContentAi = associatedPlaylist?.items?.some(
              (i) => i?.type === "contentAI"
            ) ?? false;


            return (
              <Grid item xs={12} sm={6} key={layoutItem.id}>
                <Box
                  sx={{
                    border:
                      selectedLayoutId === layoutItem.id
                        ? "3px solid #4caf50"
                        : "1px solid #f5f5f5",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderRadius: "10px",
                    boxShadow: 2,
                    padding: 1,
                    transition: "border 0.3s ease",
                  }}
                  onClick={() => handleSelectLayout(layoutItem.id)}
                >
              

                  <Box sx={{ width: "100%", flexGrow: 1 }}>
                    {associatedPlaylist?.items?.[0] ? (
                      <Box>
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                        
                          {(() => {
                            const item = associatedPlaylist.items[0];
                            const matchedEntry = dataToDisplay.find(
                              (entry) => entry.id === item?.content_ref
                            );

                            return (
                              <Box
                                key={matchedEntry?.id || associatedPlaylist.id}
                              >
                                {matchedEntry?.customProperties?.html && (
                                  <iframe
                                    title="template-content"
                                    srcDoc={matchedEntry.customProperties.html}
                                    style={{
                                      width: "100%",
                                      height: "150px",
                                      border: "none",
                                      borderRadius: "10px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  />
                                )}

                             
                                {(matchedEntry?.customisations?.[0]?.imageUrl ||
                                  matchedEntry?.imageUrl) &&
                                  (() => {
                                    const mediaUrl =
                                      matchedEntry?.customisations?.[0]
                                        ?.imageUrl || matchedEntry?.imageUrl;
                                    const isVideo = /\.(mp4|webm|avi|mov)$/i.test(
                                      mediaUrl
                                    ); 

                                    return isVideo ? (
                                      <CardMedia
                                        component="video"
                                        src={mediaUrl}
                                        controls
                                        sx={{
                                          width: "100%",
                                          height: "150px",
                                          objectFit: "cover",
                                          borderRadius: "10px",
                                        }}
                                      />
                                    ) : (
                                      <CardMedia
                                        component="img"
                                        image={mediaUrl || "placeholder.jpg"}
                                        alt="Content Image"
                                        sx={{
                                          width: "100%",
                                          height: "150px",
                                          objectFit: "cover",
                                          borderRadius: "10px",
                                        }}
                                      />
                                    );
                                  })()}
                              </Box>
                            );
                          })()}
                        </CardContent>
                      </Box>
                    ) : (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ textAlign: "center" }}
                      >
                        No playlist content available
                      </Typography>
                    )}
                  </Box>
                  <Typography
                    variant="body"
                    color="primary"
                    sx={{ textAlign: "center" }}
                  >
                    {layoutItem?.name}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedLayoutId === layoutItem.id}
                          onChange={() => {
                            if (isMobile && isContentAi) {
                              setShowNotSupportedActionModal(true)
                            }
                            else {
                              handleSelectLayout(layoutItem.id);
                              handleOpen();
                            }
                          }}
                          color="success"
                        />
                      }
                      label="Edit Layout"
                    />
                  </Box>
                  {selectedLayoutId === layoutItem.id && (
                    <InputLayoutForm
                      layoutItem={layoutItem}
                      open={open}
                      onClose={handleClose}
                    />
                  )}
                </Box>
              </Grid>
            );
          })}
        </Grid>

        <div style={{ marginTop: "1.5rem" }}>
          <MyLayoutForm />
        </div>
      </Box>

      <ActionNotSupportedAlert 
      open={showNotSupportedActionModal} 
      setOpen={setShowNotSupportedActionModal} 
      title="Content AI layouts are not supported when creating events on mobile devices."
      subline = "Please use the desktop application for a better experience."
      />
    </>
  );
};

export default LayoutSmallCardComponent;
